<template>
  <div class="grid-string import-list-header-string">
    <div class="cell cell-header" />
    <div v-for="field in order" :key="field.slug" class="cell cell-header">
      {{ field.text }}
    </div>
  </div>
</template>
{

<script>
  export default {
    name: 'ImportListHeader',
    props: {
      order: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>
